import { firstLoading, secondLoading } from './loading'
import { delayTransition, beforeAnimateTransition, afterAnimateTransition } from './transition'
import { mediaQuery, breakPoint } from './mediaquery'
import { openPopup, closePopup } from './popup'
import { pathAnimateShuffle, pathAnimateLogo, pathAnimateThumbnail } from './pathAnimate'
import { initTopRandom } from './top-random'

// meta系の更新
const updateMeta = (next) => {
  const { head } = document
  const targetHead = next.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0]
  const newPageHead = document.createElement('head')
  newPageHead.innerHTML = targetHead
  const removeHeadTags = [
    "meta[name='robots']",
    "meta[name='keywords']",
    "meta[name='description']",
    "meta[property='og:title']",
    "meta[property='og:type']",
    "meta[property='og:url']",
    "meta[property='og:image']",
    "meta[property='og:image:width']",
    "meta[property='og:image:height']",
    "meta[property='og:description']",
    "meta[property='og:site_name']",
    "link[rel='alternate']",
    "link[rel='canonical']",
    "link[rel='next']",
    "link[rel='prev']",
  ].join(',')
  const headTags = [...head.querySelectorAll(removeHeadTags)]
  const newHeadTags = [...newPageHead.querySelectorAll(removeHeadTags)]
  headTags.forEach((item) => head.removeChild(item))
  newHeadTags.forEach((item) => head.appendChild(item))

  // ga
  if (typeof ga === 'function') ga('send', 'pageview', window.location.pathname) // eslint-disable-line no-undef
  if (typeof gtag === 'function')
    gtag('config', 'G-M0GC4EEY2X', { page_path: window.location.pathname }) // eslint-disable-line no-undef
}

const body = document.body
const delay = 250

/**
 * ua
 */
// if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
//   body.classList.add('mobile')
// }

/**
 * gsapのWarningの非表示
 */
gsap.config({
  nullTargetWarn: false,
  trialWarn: false,
})

/**
 * swiper
 * top
 */
let swiperTop
const options = {
  direction: 'vertical',
  loop: true,
  lazy: true,
  autoplay: {
    delay: 10000,
    disableOnInteraction: false,
  },
  speed: 650,
  navigation: {
    nextEl: '.top-next',
    prevEl: '.top-prev',
  },
  // initialSlide: 0,
  on: {
    transitionStart: () => {
      const videos = document.querySelectorAll('video')
      Array.prototype.forEach.call(videos, (video) => {
        video.pause()
      })
    },
    transitionEnd: (e) => {
      const activeIndex = e.activeIndex
      const activeSlide = document.querySelectorAll('.swiper-slide')[activeIndex]
      const activeSlideVideo = activeSlide.querySelector('video')
      if (activeSlideVideo !== null) {
        activeSlideVideo.currentTime = 0
        setTimeout(() => {
          activeSlideVideo.play()
        }, 1)
      }
    },
    slideChange() {
      document.querySelectorAll('.swiper-slide .top-article_bar').forEach((topArticleBar) => {
        topArticleBar.classList.remove('active')
      })
      setTimeout(() => {
        document.querySelector('.swiper-slide-active .top-article_bar').classList.add('active')
      }, 10)
    },
  },
}
const createSwiperTop = (options) => {
  swiperTop = new Swiper('.top-swiper', options)
}

/**
 * swiper
 * work
 */
let swiperWork
const createSwiperWork = () => {
  swiperWork = new Swiper('.work-swiper', {
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })
}

/**
 * mediaQuery
 */
mediaQuery()

/**
 * pathAnimate
 */
const changeBreakPoint = (e) => {
  if (e.matches) {
    // pc
    pathAnimateLogo()
    pathAnimateShuffle()
  }
}
changeBreakPoint(breakPoint)
breakPoint.addListener(changeBreakPoint)

/**
 * shuffleボタン
 */
const jsShuffleTops = document.querySelectorAll('.js-shuffleTop')
const jsShuffleNotTops = document.querySelectorAll('.js-shuffleNotTop')
let isShuffle = false
let isShuffleAnimate = false
const shuffleAnimate = () => {
  const topArticles = document.querySelectorAll('.top-article')
  const topArticleLength = topArticles.length
  const topShuffleThumbnail = document.querySelector('.top-shuffle_thumbnail')
  let arrayImg = []

  /**
   * 画像をactiveのものから、あとは適当に配列に入れていく
   */
  const active = document.querySelector('.swiper-slide-active .top-article_img')
  arrayImg.unshift(active.src)
  if (topArticleLength < 4) {
    topArticles.forEach((topArticle) => {
      if (!topArticle.classList.contains('swiper-slide-active')) {
        arrayImg.unshift(topArticle.querySelector('.top-article_img').src)
      }
    })
  } else {
    for (let i = 0; i < 4; i++) {
      if (!topArticles[i].classList.contains('swiper-slide-active')) {
        arrayImg.unshift(topArticles[i].querySelector('.top-article_img').src)
      }
    }
  }

  /**
   * 配列に入れた画像をDOMにする
   */
  arrayImg.forEach((element) => {
    if (element.includes('mp4')) {
      const createVideo = document.createElement('video')
      createVideo.src = element
      createVideo.loading = 'lazy'
      createVideo.classList.add('js-shuffleImg')
      topShuffleThumbnail.append(createVideo)
    } else {
      const createImg = document.createElement('img')
      createImg.src = element
      createImg.loading = 'lazy'
      createImg.classList.add('js-shuffleImg')
      topShuffleThumbnail.append(createImg)
    }
  })

  gsap.set('.top-articles_wrapper', {
    willChange: 'transform, opacity',
  })
  gsap.set('.js-shuffleImg', {
    willChange: 'transform, opacity',
  })

  gsap
    .timeline()
    .to('.top-article_detail', {
      duration: 0.7,
      ease: 'expo.out',
      y: '-10px',
      opacity: 0,
      onComplete: () => {
        gsap.set(['.wrapper', '.top-articles'], {
          overflow: 'visible',
        })
        gsap.set('.top-shuffle', {
          display: 'flex',
        })
        // swiperを一旦削除
        swiperTop.destroy(true, true)
        gsap.set('.top-articles_wrapper', {
          opacity: 0,
          y: '-20px',
        })
      },
    })
    .to('.js-shuffleImg', {
      stagger: {
        amount: 1,
        from: 'end',
      },
      duration: 0.7,
      ease: 'power4.out',
      y: (i) => (i + 1) * -5,
      opacity: 0,
      onComplete: () => {
        initTopRandom()
      },
    })
    .to(
      '.top-articles_wrapper',
      {
        duration: 1,
        ease: 'power4.out',
        opacity: 1,
        y: 0,
        onComplete: () => {
          gsap.set('.top-shuffle', {
            display: 'none',
          })
          // swiper復活
          createSwiperTop(options)
        },
      },
      2.5
    )
    .to(
      '.top-article_detail',
      {
        duration: 0.7,
        ease: 'expo.out',
        y: 0,
        opacity: 1,
        onComplete: () => {
          gsap.set(['.wrapper', '.top-articles'], {
            overflow: 'hidden',
          })
          gsap.set('.top-article', {
            willChange: 'auto',
          })
          gsap.set('.js-shuffleImg', {
            willChange: 'auto',
          })
          while (topShuffleThumbnail.firstChild) {
            topShuffleThumbnail.removeChild(topShuffleThumbnail.firstChild)
          }
          setTimeout(() => {
            isShuffleAnimate = false
          }, 800)
        },
      },
      2.8
    )
}

/**
 * shuffleボタンクリック
 * topページのみ
 */
jsShuffleTops.forEach((jsShuffleTop) => {
  jsShuffleTop.addEventListener('click', () => {
    if (!isShuffleAnimate) {
      isShuffleAnimate = true
      shuffleAnimate()
    }
  })
})

/**
 * shuffleボタンクリック
 * topページ以外
 */
jsShuffleNotTops.forEach((jsShuffleNotTop) => {
  jsShuffleNotTop.addEventListener('click', () => {
    if (!isShuffleAnimate) {
      isShuffle = true
      isShuffleAnimate = true
    }
  })
})

/**
 * barba.js
 * 初期設定
 */
barba.hooks.before(() => {
  document.querySelector('html').classList.add('is-transitioning')
  barba.wrapper.classList.add('is-animating')
})
barba.hooks.after(() => {
  document.querySelector('html').classList.remove('is-transitioning')
  barba.wrapper.classList.remove('is-animating')
  window.scrollTo(0, 0)
})

barba.init({
  debug: true,
  sync: true,
  views: [
    {
      namespace: 'top',
      beforeEnter() {
        document.querySelector('html').style.overflow = 'hidden'
        body.classList.add('top')

        /**
         * ランダム表示
         */
        initTopRandom()

        /**
         * swiperの作成
         */
        if (document.querySelector('.top-swiper') !== null) {
          createSwiperTop(options)

          /**
           * ブレイクポイントでアニメーション切り替え
           * @param e
           */
          const changeBreakPoint = (e) => {
            if (e.matches) {
              // pc
              options.direction = 'horizontal'
              options.effect = 'fade'
              options.fadeEffect = {
                crossFade: true,
              }
              options.speed = 500
            } else {
              // mobile
              options.direction = 'vertical'
              options.effect = 'slide'
              options.fadeEffect = ''
              options.speed = 650
            }
            swiperTop.destroy(true, true)
            createSwiperTop(options)
          }
          changeBreakPoint(breakPoint)
          breakPoint.addListener(changeBreakPoint)
        }

        /**
         * 画面の切り替え
         */
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'hidden') {
            /**
             * hidden
             */
            swiperTop.destroy(true, true)
          } else {
            /**
             * visible
             */
            createSwiperTop(options)
          }
        })

        /**
         * shuffleボタンから遷移
         * topページ以外
         */
        if (isShuffle) {
          setTimeout(() => {
            isShuffle = false
            shuffleAnimate()
          }, 500)
        }

        // ツールバーから不要な項目を削除
        setTimeout(() => {
          if (document.querySelector('#wp-admin-bar-edit') !== null) {
            document.querySelector('#wp-admin-bar-edit').remove()
          }
          if (document.querySelector('#wp-admin-bar-duplicate-post') !== null) {
            document.querySelector('#wp-admin-bar-duplicate-post').remove()
          }
        }, 550)
      },
      afterLeave() {
        document.querySelector('html').style.overflow = 'auto'
        body.classList.remove('top')

        /**
         * videoの停止
         */
        document.querySelectorAll('video').forEach((video) => {
          video.pause()
        })

        /**
         * swiperの削除
         */
        if (document.querySelector('.top-swiper') !== null) {
          swiperTop.destroy(true, true)
        }
      },
    },
    {
      namespace: 'archive',
      beforeEnter() {
        body.classList.add('archive')

        // ツールバーから不要な項目を削除
        setTimeout(() => {
          if (document.querySelector('#wp-admin-bar-edit') !== null) {
            document.querySelector('#wp-admin-bar-edit').remove()
          }
          if (document.querySelector('#wp-admin-bar-duplicate-post') !== null) {
            document.querySelector('#wp-admin-bar-duplicate-post').remove()
          }
        }, 550)
      },
      afterLeave() {
        body.classList.remove('archive')
      },
    },
    {
      namespace: 'single',
      beforeEnter({ next }) {
        const container = next.container
        body.classList.add('single')

        /**
         * pathAnimate
         */
        pathAnimateThumbnail()

        /**
         * tableの設定
         */
        document.querySelectorAll('table td').forEach((tableTd) => {
          if (tableTd.clientHeight >= 100) tableTd.classList.add('isLong')
        })
        document.querySelectorAll('table tr').forEach((tableTr) => {
          if (tableTr.children.length === 1) tableTr.querySelector('td').classList.add('isOnly')
        })

        /**
         * swiperの作成
         */
        if (document.querySelector('.work-slider') !== null) {
          createSwiperWork()
        }

        /**
         * videoの再生
         */
        setTimeout(() => {
          document.querySelectorAll('video').forEach((video) => {
            video.play()
          })
        }, 10)

        /**
         * popup
         * 設定
         */
        let isOpen = false
        const wpBlockImages = next.container.querySelectorAll('.wp-block-image')

        /**
         * popup
         * open
         */
        wpBlockImages.forEach((wpBlockImage) => {
          wpBlockImage.addEventListener('click', (e) => {
            if (!isOpen) {
              isOpen = true
              openPopup(e)
            }
          })
        })

        /**
         * popup
         * close
         */
        window.addEventListener('scroll', () => {
          if (isOpen) {
            closePopup()
            isOpen = false
          }
        })
        document.querySelector('.overlay').addEventListener('click', () => {
          if (isOpen) {
            closePopup()
            isOpen = false
          }
        })

        // スムーススクロール
        const anchors = container.querySelectorAll('a[href^="#"]')
        anchors.forEach((anchor) => {
          anchor.addEventListener('click', (e) => {
            e.preventDefault()
            const href = anchor.getAttribute('href')
            const target = document.getElementById(href.replace('#', ''))
            const targetPosition = target.getBoundingClientRect().top + window.pageYOffset
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth',
            })
            setTimeout(() => {
              const newPosition = target.getBoundingClientRect().top + window.pageYOffset
              if (targetPosition !== newPosition) {
                window.scrollTo({
                  top: targetPosition,
                  behavior: 'smooth',
                })
              }
            }, 300)
          })
        })

        // form 送信ボタンの調整
        if (document.querySelector('.wpcf7-submit') !== null) {
          const wpcf7Submit = document.querySelector('.wpcf7-submit')
          const newSpan = document.createElement('span')
          const p = wpcf7Submit.parentElement
          p.classList.add('button')
          p.insertBefore(newSpan, wpcf7Submit.parentElement.firstChild)
          p.querySelector('span').appendChild(wpcf7Submit)
        }

        // https://test.hagiso.com/のリンク修正
        setTimeout(() => {
          const links = container.querySelectorAll('a')
          links.forEach((link) => {
            const href = link.getAttribute('href')
            if (href === null) return false
            if (href.includes('test.')) {
              const newHref = href.replace('test.', '')
              link.setAttribute('href', newHref)
            }
          })
        }, 400)

        // ツールバー「投稿を編集」のリンク修正
        setTimeout(() => {
          // ツールバーから不要な項目を削除
          if (document.querySelector('#wp-admin-bar-duplicate-post') !== null) {
            document.querySelector('#wp-admin-bar-duplicate-post').remove()
          }

          const postid = container.dataset.postid
          const newHref = `${location.protocol}//${location.host}/wp-admin/post.php?post=${postid}&action=edit`

          if (document.querySelector('#wp-admin-bar-edit .ab-item') !== null) {
            const wpAdminBarEditAbItem = document.querySelector('#wp-admin-bar-edit .ab-item')
            wpAdminBarEditAbItem.setAttribute('href', newHref)
          } else {
            if (container.dataset.admin === 'admin') {
              const wpAdminBarRootDefault = document.querySelector('#wp-admin-bar-root-default')
              const newLi = document.createElement('li')
              const newA = document.createElement('a')
              newLi.setAttribute('id', 'wp-admin-bar-edit')
              newA.classList.add('ab-item')
              newA.innerText = '投稿を編集'
              newA.setAttribute('href', newHref)
              newLi.appendChild(newA)
              wpAdminBarRootDefault.appendChild(newLi)
            }
          }
        }, 250)
      },
      afterLeave() {
        body.classList.remove('single')

        /**
         * tableのクラス削除
         */
        document.querySelectorAll('table td').forEach((tableTd) => {
          tableTd.classList.remove('isLong')
          tableTd.classList.remove('isOnly')
        })

        /**
         * swiperの削除
         */
        if (document.querySelector('.work-slider') !== null) {
          swiperWork.destroy(false, true)
        }

        /**
         * videoの停止
         */
        document.querySelectorAll('video').forEach((video) => {
          video.pause()
        })
      },
    },
    {
      namespace: 'page',
      beforeEnter({ next }) {
        const container = next.container
        body.classList.add('page')

        if (container.classList.contains('place')) {
          pathAnimateThumbnail()
        }
      },
      afterLeave() {
        body.classList.remove('page')
      },
    },
  ],
  transitions: [
    {
      once({ next }) {
        const namespace = next.namespace

        /**
         * 初期設定
         * preloadの削除
         */
        window.addEventListener('load', () => {
          body.classList.remove('preload')
        })

        // セッションストレージで初回アクセス取得
        if (!sessionStorage.getItem('firstAccess')) {
          // 初回アクセス時
          sessionStorage.setItem('firstAccess', 0)
          firstLoading(namespace)
        } else {
          // 二回目アクセス以降
          secondLoading()
          // firstLoading(namespace)
        }
      },
      async leave() {
        const done = this.async()
        beforeAnimateTransition()
        await delayTransition(delay)
        done()
      },
      beforeEnter({ next }) {
        updateMeta(next)

        /**
         * mediaQuery
         */
        mediaQuery(next.container)

        /**
         * 初期ローディングで見えなくなるので、
         * ページ遷移時に見えるように設定
         */
        gsap.set('.wrapper', {
          autoAlpha: 1,
        })
        gsap.set('.top-prev', {
          autoAlpha: 1,
        })
        gsap.set('.top-next', {
          autoAlpha: 1,
        })
      },
      enter() {
        afterAnimateTransition()
      },
    },
  ],
  prevent: (e) => {
    if (e.el.classList.contains('ab-item')) {
      return true
    }
  },
})
